import { addAuthenticationInterceptors } from '@publicisgroupe/p-os-authentication';
import axios from 'axios';

// We cannot use static axios, because
// its customizations (such as interceptors)
// may leak to other users and cause unwanted issues.
// So we return a customized instance here.
const axiosInstance = axios.create();
addAuthenticationInterceptors(axiosInstance);

export default axiosInstance;
